import React, { useMemo } from 'react';
import styled, { css } from 'styled-components/macro';
import { responsive } from '../../../resources/constantes.json';
import RepartoCurules from './RepartoCurules';
import RepartoVotos from './RepartoVotos';
import LeyendaPartidos from '../../../components/Grafica/Leyenda/LeyendaPartidos';

const RepartoVotosTerritorios = ({
  camaraSeleccionada,
  eleccion,
  mostrarCargos,
}) => {
  return (
    <div
      css={`
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin: 0 auto;
        height: 100%;
        @media screen and (max-width: ${responsive.tablet}px) {
          flex-direction: column;
          align-items: center;
        }
      `}
    >
      {mostrarCargos && (
        <RepartoCurules
          camaraSeleccionada={camaraSeleccionada}
          eleccion={eleccion}
        />
      )}
      <RepartoVotos camaraSeleccionada={camaraSeleccionada} />
      <Leyenda camaraSeleccionada={camaraSeleccionada} />
    </div>
  );
};

export const Leyenda = ({
  camaraSeleccionada,
  stylesLeyendaContainer,
  styleLeyendaPartido,
}) => {
  const convocatoria = 'act';
  const partidos = camaraSeleccionada.partotabla.filter(
    p => p[convocatoria].pvot !== '0%'
  );
  const sinInfo = Number(camaraSeleccionada.carg) === 0 && false;
  const totales = camaraSeleccionada.carg;
  return (
    <LeyendaContainer style={stylesLeyendaContainer}>
      <LeyendaPartidos
        stylesLeyendaContainer={stylesLeyendaContainer}
        styleLeyendaPartido={styleLeyendaPartido}
        data={partidos}
        sinInfo={sinInfo}
        totales={totales}
      />
    </LeyendaContainer>
  );
};

const LeyendaContainer = styled.div`
  float: left;
  margin-top: 20px;
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
  }
  @media (max-width: ${responsive.mobile}px) {
    width: 100%;
  }
`;

export default RepartoVotosTerritorios;
